import { useEffect, useState } from 'react';
import { IonCheckbox, IonIcon, IonItem, IonLabel, IonList } from '@ionic/react';
import { documentOutline } from 'ionicons/icons';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import { Autocomplete, TextField } from '@mui/material';
import StepLayout from './StepLayout';
import { modalToggleStore, profileFormStore, toggleStore } from '../../../store/Store';

const ApplyPermit1 = () => {
    const settingsForm = profileFormStore.useState((s) => s.settingsForm);
    const agreeRules = toggleStore.useState((s) => s.agreeRules);
    const [streets, setStreets] = useState([]);
    const [selectedStreet, setSelectedStreet] = useState(null);

    const firestore = getFirestore();

    useEffect(() => {
        const unsubscribe = onSnapshot(
            collection(firestore, 'municipalities/parrysound/streets'),
            (snapshot) => {
                const streetsList = snapshot.docs.map((doc) => doc.data().name || '');
                setStreets(streetsList.sort((a, b) => a.localeCompare(b)));
            }
        );

        return () => unsubscribe();
    }, [firestore]);

    const setAgree = (checked) => {
        toggleStore.update((s) => {
            s.agreeRules = checked;
        });
    };

    const openSecondPage = () => {
        modalToggleStore.update((s) => {
            s.permitPage = 2;
        });
    };

    let hint;
    if (!selectedStreet) {
        hint = 'Select your street to continue.';
    } else if (!agreeRules) {
        hint = 'Tick the box to agree to the by-law terms to continue.';
    }

    return (
        <StepLayout
            title='Please confirm your street and agree to the by-law terms and conditions'
            primaryLabel='Continue'
            onPrimary={openSecondPage}
            primaryDisabled={Boolean(hint)}
            hint={hint}
        >
            <Autocomplete
                id='permit-street'
                options={streets}
                value={selectedStreet}
                onChange={(event, newValue) => setSelectedStreet(newValue)}
                disablePortal
                autoHighlight
                openOnFocus
                noOptionsText='No matching street'
                renderInput={(params) => (
                    <TextField {...params} label='Select your street' variant='outlined' fullWidth />
                )}
            />
            <p className='flow-step__lead'>
                Don't see your street? Please confirm that your property is serviced by Parry Sound
                Fire Department before proceeding.
            </p>
            <p>
                <a
                    className='flow-document-link'
                    href={settingsForm.byLaw}
                    target='_blank'
                    rel='noreferrer'
                >
                    <IonIcon icon={documentOutline} aria-hidden='true' />
                    <span>
                        The Corporation of the Town of Parry Sound By-law 2021-7170
                        <span className='flow-sr-only'> (opens in a new tab)</span>
                    </span>
                </a>
            </p>
            <IonList lines='full'>
                <IonItem>
                    <IonCheckbox
                        slot='start'
                        color='tertiary'
                        checked={agreeRules}
                        onIonChange={(e) => setAgree(e.detail.checked)}
                    />
                    <IonLabel className='ion-text-wrap'>
                        I have read, and I agree to abide by all of the terms and conditions set
                        forth in The Corporation of the Town of Parry Sound By-law 2021 - 7170.{' '}
                        <strong>
                            I also attest that my property is on the selected street and understand
                            that if I incorrectly apply with another address, my application fee may
                            not be returned
                        </strong>
                        .
                    </IonLabel>
                </IonItem>
            </IonList>
        </StepLayout>
    );
};

export default ApplyPermit1;
